import { Roles } from '../../Types/interfaces';
import InternshipListComponent from '../InternshipList/InternshipListComponent';
import { MenuGroups, MenuKeys } from '../../Constants/menuKeys';
import InternshipProcessComponent from '../InternshipProcessComponent';
import ResearchAgreementComponent from '../ResearchAgreement/ResearchTopicAgreementComponent';
import ReviewComponent from '../WorkReport/ReviewComponent';
import ListResearchAgreementsComponents from '../ResearchAgreement/ListResearchAgreementsComponents';
import GradingComponent from '../GradingComponent';
import SummaryTableSelector from '../SummaryTable/SummaryTableSelector';
import SupervisorAssignmentComponent from '../SupervisorComponents/SupervisorAssignmentComponent';
import OrganizationListComponent from '../Organization/OrganizationListComponent';
import TutorManagementComponent from '../TutorManagement/TutorManagementComponent';
import InternshipManagementComponent from '../InternshipManagement/InternshipManagementComponent';
import { SupervisorManagementComponent } from '../SupervisorComponents/SupervisorManagementComponent';
import CollaborationSigningComponent from '../CollaborationSigningComponent';
import LegalDepartmentComponent from '../LegalDepartment/LegalDepartmentComponent';
import ConventionSignComponent from '../ConventionSignComponent';
import React from 'react';
import {
  PiCheckCircle,
  PiClipboardTextFill,
  PiMagnifyingGlassPlus,
  PiShieldCheckFill,
  PiStudentFill,
  PiTableFill,
} from 'react-icons/pi';
import { GiArchiveResearch } from 'react-icons/gi';
import { GoOrganization } from 'react-icons/go';
import { HiUsers } from 'react-icons/hi2';
import { IoDocuments, IoSettingsOutline } from 'react-icons/io5';
import { FaUserGear, FaUserPlus } from 'react-icons/fa6';
import { RiUserShared2Line } from 'react-icons/ri';
import { LuPenTool } from 'react-icons/lu';
import { UniversityAddMemberComponent } from '../UniversityAddMemberComponent';
import { CreateUniversityComponent } from '../UniversityForm/CreateUniversityComponent';
import { StudyYearSetupComponent } from '../UniversityForm/StudyYearSetupComponent';
import OrganizationFormComponent from '../Organization/OrganizationFormComponent';
import { UniversityOrganizationRegistration } from '../Organization/UniversityOrganizationRegistration';
import { FaBuildingCircleCheck } from 'react-icons/fa6';
import { BsBuildingAdd } from 'react-icons/bs';
import { SupervisorStudentDocumentList } from '../SupervisorComponents/SupervisorStudentDocumentList';
import { RepresentativeStudentDocumentList } from '../RepresentativeDocumentList';
import { CgFileDocument } from 'react-icons/cg';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { PendingInternshipOffersComponent } from '../InternshipManagement/PendingInternshipOffersComponent';
import { PiClockCountdownBold } from 'react-icons/pi';
import { StudyYearsComponent } from '../StudyYears/StudyYearsComponent';
import { SafetyDocumentTable } from '../LegalDepartment/SafetyDocumentTable';
import { UniversityProjectCoordinatorComponent } from '../UniversityProjectCoordinatorComponent';
import { ProcessStartSettingsComponent } from '../ProcessStartSettingsComponent';
import { ProcessRollbackComponent } from '../ProcessRollback/ProcessRollbackComponent';
import { PiArrowCounterClockwiseBold } from 'react-icons/pi';

export interface DashboardRoute {
  key: string;
  labelKey: string; // the translate (i18n) key only
  icon: React.ReactNode;
  path: string; // must be unique in dashboardRoutes
  roles?: number[] | null;
  excludedRoles?: number[];
  component: React.ReactNode;
  rule?: (email: string) => boolean;
}

export interface GroupedDashboardRoute extends DashboardRoute {
  groupKey: string;
  groupLabel: string;
}

export const dashboardRoutes: (DashboardRoute | GroupedDashboardRoute)[] = [
  {
    labelKey: 'homePage.intList',
    key: MenuKeys.InternshipOffers,
    icon: <PiMagnifyingGlassPlus />,
    roles: [Roles.Student],
    component: <InternshipListComponent />,
    path: 'student/internship-offers',
    groupKey: MenuGroups.Student,
    groupLabel: 'roles.student',
  },
  {
    labelKey: 'homePage.intProcesses',
    key: MenuKeys.InternshipProcesses,
    icon: <PiCheckCircle />,
    roles: [Roles.Student],
    component: <InternshipProcessComponent />,
    path: 'student/internship-processes',
    groupKey: MenuGroups.Student,
    groupLabel: 'roles.student',
  },
  {
    labelKey: 'homePage.pendingInternshipOffers',
    key: MenuKeys.PendingProcesses,
    icon: <PiClockCountdownBold />,
    roles: [Roles.Student],
    component: <PendingInternshipOffersComponent />,
    path: 'student/pending-processes',
    groupKey: MenuGroups.Student,
    groupLabel: 'roles.student',
  },
  {
    labelKey: 'homePage.researchAgreements',
    key: MenuKeys.ResearchAgreement,
    icon: <GiArchiveResearch />,
    roles: [Roles.Student],
    component: <ResearchAgreementComponent />,
    path: 'student/research-agreements',
    groupKey: MenuGroups.Student,
    groupLabel: 'roles.student',
  },
  {
    labelKey: 'homePage.uniMemberManager',
    key: MenuKeys.ManageUnuversityMembers,
    icon: <PiMagnifyingGlassPlus />,
    roles: [Roles.Administrator],
    component: <UniversityAddMemberComponent />,
    path: 'administrator/member-manager',
    groupKey: MenuGroups.Administrator,
    groupLabel: 'roles.administrator',
  },
  {
    labelKey: 'homePage.universityForm',
    key: MenuKeys.CreateUniversity,
    icon: <PiMagnifyingGlassPlus />,
    roles: [Roles.Administrator],
    component: <CreateUniversityComponent />,
    path: 'administrator/register-university',
    groupKey: MenuGroups.Administrator,
    groupLabel: 'roles.administrator',
  },
  {
    labelKey: 'homePage.processStartSettings',
    key: MenuKeys.ProcessStartSettings,
    icon: <FaUserGear />,
    roles: [Roles.Administrator],
    component: <ProcessStartSettingsComponent />,
    path: 'administrator/process-start-settings',
    groupKey: MenuGroups.Administrator,
    groupLabel: 'roles.administrator',
  },
  {
    labelKey: 'homePage.processRollback',
    key: MenuKeys.ProcessRollback,
    icon: <PiArrowCounterClockwiseBold />,
    roles: [Roles.Administrator],
    component: <ProcessRollbackComponent />,
    path: 'administrator/process-rollback',
    groupKey: MenuGroups.Administrator,
    groupLabel: 'roles.administrator',
  },
  {
    labelKey: 'homePage.students',
    key: MenuKeys.Students,
    icon: <PiStudentFill />,
    roles: [Roles.Tutor],
    component: <ReviewComponent />,
    path: 'tutor/students',
    groupKey: MenuGroups.Tutor,
    groupLabel: 'roles.tutor',
  },
  {
    labelKey: 'homePage.researchAgreements',
    key: MenuKeys.ResearchAgrements,
    icon: <GiArchiveResearch />,
    roles: [Roles.Tutor],
    component: <ListResearchAgreementsComponents />,
    path: 'tutor/research-agreements',
    groupKey: MenuGroups.Tutor,
    groupLabel: 'roles.tutor',
  },
  {
    labelKey: 'homePage.manageDocuments',
    key: MenuKeys.StudentEvaluationSupervisor,
    icon: <CgFileDocument />,
    roles: [Roles.CadruDidactic],
    component: <GradingComponent />,
    path: 'supervisor/grade-students',
    groupKey: MenuGroups.Supervisor,
    groupLabel: 'roles.supervisor',
  },
  {
    labelKey: 'homePage.docs',
    key: MenuKeys.Docs,
    icon: <IoDocuments />,
    roles: [Roles.CadruDidactic],
    component: <SupervisorStudentDocumentList />,
    path: 'supervisor/documents',
    groupKey: MenuGroups.Supervisor,
    groupLabel: 'roles.supervisor',
  },
  {
    labelKey: 'homePage.studentAssign',
    key: MenuKeys.StudentAssign,
    icon: <FaUserPlus />,
    roles: [Roles.CadruDidactic],
    component: <SupervisorAssignmentComponent isCoordinatorMenu={false} />,
    path: 'supervisor/assign-students',
    groupKey: MenuGroups.Supervisor,
    groupLabel: 'roles.supervisor',
  },
  {
    labelKey: 'homePage.registeredOrgs',
    key: MenuKeys.RegisteredOrganizations,
    icon: <FaBuildingCircleCheck />,
    roles: [Roles.OrganizationRepresentative],
    component: <OrganizationListComponent />,
    path: 'organization-representative/registered-oraganizations',
    groupKey: MenuGroups.OrganizationRepresentative,
    groupLabel: 'roles.representativeOrganization',
  },
  {
    labelKey: 'homePage.tutors',
    key: MenuKeys.ReprezentativeOrganization,
    icon: <HiUsers />,
    roles: [Roles.OrganizationRepresentative],
    component: <TutorManagementComponent />,
    path: 'organization-representative/tutors',
    groupKey: MenuGroups.OrganizationRepresentative,
    groupLabel: 'roles.representativeOrganization',
  },
  {
    labelKey: 'homePage.intManage',
    key: MenuKeys.ManageInternshipsOrganizationRepresentative,
    icon: <PiClipboardTextFill />,
    roles: [Roles.OrganizationRepresentative],
    component: <InternshipManagementComponent />,
    path: 'organization-representative/manage-internships',
    groupKey: MenuGroups.OrganizationRepresentative,
    groupLabel: 'roles.representativeOrganization',
  },
  {
    labelKey: 'homePage.docs',
    key: MenuKeys.RepresentativeDocs,
    icon: <PiClipboardTextFill />,
    roles: [Roles.OrganizationRepresentative],
    component: <RepresentativeStudentDocumentList />,
    path: 'organization-representative/documents',
    groupKey: MenuGroups.OrganizationRepresentative,
    groupLabel: 'roles.representativeOrganization',
  },
  {
    labelKey: 'homePage.supvisManage',
    key: MenuKeys.ManageSupervisors,
    icon: <FaUserGear />,
    roles: [Roles.UniversityCoordinator],
    component: <SupervisorManagementComponent />,
    path: 'university-coordonator/manage-supervisors',
    groupKey: MenuGroups.UniversityCoordonator,
    groupLabel: 'roles.universityCoordonator',
  },
  {
    labelKey: 'homePage.supvisAssign',
    key: MenuKeys.SupervisorAssign,
    icon: <RiUserShared2Line style={{ marginLeft: -2 }} />,
    roles: [Roles.UniversityCoordinator],
    component: <SupervisorAssignmentComponent isCoordinatorMenu={true} />,
    path: 'university-coordonator/assign-supervisors',
    groupKey: MenuGroups.UniversityCoordonator,
    groupLabel: 'roles.universityCoordonator',
  },
  {
    labelKey: 'homePage.researchAgreements',
    key: MenuKeys.ResearchAgrementsForUniversityCoordonator,
    icon: <GiArchiveResearch />,
    roles: [Roles.UniversityCoordinator],
    component: <ListResearchAgreementsComponents isCoordinator={true} />,
    path: 'university-coordonator/research-agreement',
    groupKey: MenuGroups.UniversityCoordonator,
    groupLabel: 'roles.universityCoordonator',
  },
  {
    labelKey: 'homePage.orgs',
    key: MenuKeys.OrganizationsLegalDepartment,
    icon: <GoOrganization />,
    roles: [Roles.LegalDepartment],
    component: <CollaborationSigningComponent signingMode="legal" />,
    path: 'legal-department/organizations',
    groupKey: MenuGroups.LegalDepartment,
    groupLabel: 'roles.legalDepartment',
  },
  {
    labelKey: 'homePage.conventions',
    key: MenuKeys.Conventions,
    icon: <LuPenTool />,
    roles: [Roles.LegalDepartment],
    component: <LegalDepartmentComponent />,
    path: 'legal-department/conventions',
    groupKey: MenuGroups.LegalDepartment,
    groupLabel: 'roles.legalDepartment',
  },
  {
    labelKey: 'homePage.safetyDocuments',
    key: MenuKeys.SafetyDocuments,
    icon: <PiShieldCheckFill />,
    roles: [Roles.LegalDepartment],
    component: <SafetyDocumentTable />,
    path: 'legal-department/safety-documents',
    groupKey: MenuGroups.LegalDepartment,
    groupLabel: 'roles.legalDepartment',
  },
  {
    labelKey: 'homePage.orgs',
    key: MenuKeys.OrganizationsRector,
    icon: <GoOrganization />,
    roles: [Roles.Rector],
    component: <CollaborationSigningComponent signingMode="rector" />,
    path: 'rector/organizations',
    groupKey: MenuGroups.Rector,
    groupLabel: 'roles.rector',
  },
  {
    labelKey: 'homePage.intManage',
    key: MenuKeys.ManageInternshipsRector,
    icon: <PiClipboardTextFill />,
    roles: [Roles.Rector],
    component: (
      <ConventionSignComponent
        menuGroup="Rector"
        role={Roles.Rector}
        filterByStudyYear={true}
      />
    ),
    path: 'rector/manage-internships',
    groupKey: MenuGroups.Rector,
    groupLabel: 'roles.rector',
  },
  {
    labelKey: 'homePage.studyYears',
    key: MenuKeys.StudyYears,
    icon: <MdOutlineCalendarMonth />,
    roles: [Roles.Rector],
    component: <StudyYearsComponent />,
    path: 'rector/study-years',
    groupKey: MenuGroups.Rector,
    groupLabel: 'roles.rector',
  },
  {
    labelKey: 'homePage.studyYearSetup',
    key: MenuKeys.StudyYearSetup,
    icon: <IoSettingsOutline />,
    roles: [Roles.Rector],
    component: <StudyYearSetupComponent />,
    path: 'rector/study-year-setup',
    groupKey: MenuGroups.Rector,
    groupLabel: 'roles.rector',
  },
  {
    labelKey: 'homePage.manageDocuments',
    key: MenuKeys.UniversityConventions,
    icon: <CgFileDocument />,
    roles: [Roles.UniversityProjectCoordinator],
    component: <UniversityProjectCoordinatorComponent />,
    path: 'project-coordinator/conventions',
    groupKey: MenuGroups.UniversityProjectCoordinator,
    groupLabel: 'roles.universityProjectCoordinator',
  },
  {
    labelKey: 'homePage.orgReg',
    key: MenuKeys.RegisterOrganization,
    icon: <BsBuildingAdd />,
    excludedRoles: [
      Roles.Dean,
      Roles.LegalDepartment,
      Roles.LaborProtection,
      Roles.Rector,
    ],
    component: <OrganizationFormComponent />,
    path: 'register-organization',
    groupKey: MenuGroups.General,
    groupLabel: 'homePage.general',
  },
  {
    labelKey: 'homePage.universityOrganizationRegistration',
    key: MenuKeys.UniversityOrganizationRegistration,
    icon: <BsBuildingAdd />,
    excludedRoles: [Roles.Student],
    component: <UniversityOrganizationRegistration />,
    path: 'university-organization-registration',
    groupKey: MenuGroups.General,
    groupLabel: 'homePage.general',
    rule: (email): boolean => {
      return email.search('ubbcluj') > -1 && email.search('stud') == -1;
    },
  },
  {
    labelKey: 'homePage.summaryTable',
    key: MenuKeys.SummaryTable,
    icon: <PiTableFill />,
    // every role except Student (a student with another role still sees it)
    roles: [
      Roles.CadruDidactic,
      Roles.Administrator,
      Roles.OrganizationRepresentative,
      Roles.Tutor,
      Roles.DepartmentRepresentative,
      Roles.Dean,
      Roles.LegalDepartment,
      Roles.LaborProtection,
      Roles.Rector,
      Roles.UniversityCoordinator,
    ],
    component: <SummaryTableSelector />,
    path: 'summary-table',
    groupKey: MenuGroups.General,
    groupLabel: 'homePage.general',
  },
];
